import { parseLegacyBp } from "./parseLegacyBp";

const notEmpty = (val) => (val != null && val !== "-" ? String(val) : "");

export const getAntenatalDefaultValues = (consultation) => {
  if (!consultation) {
    return {
      gestationWeeks: "",
      gestationDays: "",
      bloodPressureSystolic: "",
      bloodPressureDiastolic: "",
      maternalWeightKg: "",
      maternalHeightCm: "",
      urinalysisGlucose: "NEGATIVE",
      urinalysisProtein: "",
      urinalysisKetones: "NEGATIVE",
      urinalysisBlood: "NEGATIVE",
      urinalysisLeucocytes: "NEGATIVE",
      urinalysisNitrites: "NEGATIVE",
      ankleOedema: "",
      fundalHeightCm: "",
      uterineContractions: "",
      bmi: "",
      haemoglobin: "",
      dateOfNextVisitWeeks: "",
      impression: "",
      additionalInfo: "",
      plan: "",
    };
  }

  const legacyBp = parseLegacyBp(consultation.bloodPressure);
  const systolic = consultation.bloodPressureSystolic
    ? String(consultation.bloodPressureSystolic)
    : legacyBp.systolic;
  const diastolic = consultation.bloodPressureDiastolic
    ? String(consultation.bloodPressureDiastolic)
    : legacyBp.diastolic;

  return {
    gestationWeeks: notEmpty(consultation.gestationWeeks),
    gestationDays: notEmpty(consultation.gestationDays),
    bloodPressureSystolic: systolic,
    bloodPressureDiastolic: diastolic,
    maternalWeightKg: notEmpty(consultation.maternalWeightKg),
    maternalHeightCm: notEmpty(consultation.maternalHeightCm),
    urinalysisGlucose: consultation.urinalysisGlucose || "NEGATIVE",
    urinalysisProtein: consultation.urinalysisProtein || "",
    /*
     * A visit saved before the grades existed holds "POSITIVE", which is kept as it is rather
     * than being read as any particular grade — nobody measured one (KIN-2038).
     */
    urinalysisKetones: consultation.urinalysisKetones || "NEGATIVE",
    urinalysisBlood: consultation.urinalysisBlood || "NEGATIVE",
    urinalysisLeucocytes: consultation.urinalysisLeucocytes || "NEGATIVE",
    /*
     * Left blank, not defaulted to Negative, when the visit holds nothing. While nitrites was a
     * tick box an unticked box saved null, so null means "not recorded as positive" — which is
     * not the same statement as "tested and negative". Defaulting it would put a negative result
     * into visits whose clinician never asserted one. A new visit does start at Negative, above.
     */
    urinalysisNitrites: consultation.urinalysisNitrites || "",
    ankleOedema: consultation.ankleOedema || "",
    fundalHeightCm: notEmpty(
      consultation.fundalHeightCm ?? consultation.symphysis
    ),
    uterineContractions: consultation.uterineContractions || "",
    bmi: notEmpty(consultation.bmi ?? consultation.bodyMassIndex),
    haemoglobin: notEmpty(consultation.haemoglobin),
    dateOfNextVisitWeeks: notEmpty(consultation.dateOfNextVisitWeeks),
    impression: notEmpty(consultation.impression),
    additionalInfo: notEmpty(consultation.additionalInfo),
    plan: notEmpty(consultation.plan),
  };
};
